export const navigation = {
    aria: {
        mainpage: "Navigue vers la page d'accueil",
        uploadButton:
            "Ouvre le configurateur d'impression 3D pour télécharger le fichier",
    },
    labels: {
        account: 'Compte',
        language: 'Langue',
        uploadFile: 'Upload file',
        userPortal: 'Portail utilisateur',
    },
};
